<h2 i18n="Start a new or continue an existing Roughcheck assessment">TITLE_START_ASSESSMENT</h2>

<form [formGroup]="roughcheckForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="ref"
      i18n="Please enter the Roughcheck assessment ID"
    >LABEL_ROUGHCHECK_ASSESSMENT_ID</label>
    <input type="text" formControlName="ref" class="form-control form-control-lg">
    <small class="form-text text-muted"
      i18n="This is the Roughcheck ID."
    >INPUT_HELP_ROUGHCHECK_ASSESSMENT_ID</small>
  </div>
  <div class="form-group">
    <label for="pin"  i18n="PIN number (if required)">LABEL_PIN_IF_REQUIRED</label>
    <input type="text" formControlName="pin" class="form-control">
    <small class="form-text text-muted"
      i18n="This is the Personal Identification Number or password to access this Roughcheck."
    >INPUT_HELP_PIN</small>
  </div>

  <button
    type="submit"
    class="btn btn-primary float-end"
    [disabled]="!roughcheckForm.valid"
    i18n="Next"
  >BUTTON_NEXT</button>
  <button
    type="submit"
    (click)="onGoBack()"
    class="btn btn-secondary"
    i18n="Previous">BUTTON_PREVIOUS</button>

</form>
